
import React from 'react';

interface BenefitItem {
  icon: string;
  title: string;
  description: string;
}

const benefits: BenefitItem[] = [
  {
    icon: "✓",
    title: "Accurate",
    description: "Precise calculations you can trust"
  },
  {
    icon: "⚡",
    title: "Fast",
    description: "Get results instantly as you type"
  },
  {
    icon: "📱",
    title: "Mobile-Friendly",
    description: "Works on any device, anywhere"
  },
  {
    icon: "🛠️",
    title: "Comprehensive",
    description: "All tools in one place"
  }
];

const BenefitsSection = () => {
  return (
    <section className="py-8 mt-8">
      <h2 className="text-2xl font-bold mb-6 text-center">Why Use Our Tools?</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {benefits.map((benefit, index) => (
          <div key={index} className="p-4 rounded-md text-center border-0 bg-transparent">
            <div className="bg-blue-100 text-blue-800 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
              <span className="text-lg font-bold">{benefit.icon}</span>
            </div>
            <h3 className="font-medium mb-1">{benefit.title}</h3>
            <p className="text-sm text-gray-600">{benefit.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BenefitsSection;
